import { observable, flow, action } from 'mobx'
import { storiesApi } from 'api'
import { v4 as uuid } from 'uuid'
import { CommonStore } from 'stores/common'

export const StoriesStore = () => {
  const findVideoSource = flow(function* (storyId) {
    const response = yield this.api.findVideoSource(storyId)
    this.currentVideoSource = response
    return response
  })

  const findVideoList = flow(function* (params) {
    let options = {
      type: 'barstool_original',
      limit: 25,
      ...params
    }
    const response = yield this.api.find(options)
    this.videoList = [...this.videoList, ...response]
    return response
  })

  const setConsecutiveViewCount = action(function (count) {
    this.consecutiveViewCount = count
  })
  const startConsecutiveViewingSession = action(function () {
    this.consecutiveViewingSession = uuid()
  })

  return observable({
    ...CommonStore,
    api: storiesApi,
    findVideoSource,
    findVideoList,
    setConsecutiveViewCount,
    startConsecutiveViewingSession,
    videoList: [],
    currentVideoSource: null,
    consecutiveViewCount: 0,
    consecutiveViewingSession: null
  })
}

StoriesStore.cacheKey = 'StoriesStore'

export default StoriesStore
